// @ts-nocheck

import { createSelector } from 'reselect';

import { selectEntitiesFavoritesMatchCount } from '../../selectors/entities/favorites/entitiesFavoritesPrimary.selector';
import { type Selector } from '../../types/selectors';

type FavoriteButtonPropsType = {
  nbFavorites: number;
};

const selectFavoriteButtonProps: Selector<FavoriteButtonPropsType> = createSelector(
  [selectEntitiesFavoritesMatchCount],
  (nbFavorites) => ({
    nbFavorites,
  }),
);

export default selectFavoriteButtonProps;
